<template>
  <ve-line :data="chartData" :settings="chartSettings" :height='height' :width='width' :events="chartEvents" :extend="extend"></ve-line>
</template>

<script>
let self;
  export default {
    props:{
      chartSettings:Object,
      chartData:Object,
      height:String,
      width:String,
         extend:Object

  },
   mounted() {
      self=this
    },
    data () {
      this.chartEvents = {
        click: function (e) {
          self.$emit('click',{value:e})
        }
      }
      return{}
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/chart/Radar.vue